import React, { useEffect, useState } from "react"

// libraries
import Skeleton from "react-loading-skeleton"

// helpers
import Api from "@/_helpers/Api"

// providers
import { trans } from "@/_providers/Translation"
import { getColorVariationFromPrimaryColorBasedOnIndex } from "@/_helpers/calculateColor"

function getCategoriesFromApi(apiChartData) {
  if (!apiChartData) return []
  const labels = Array.isArray(apiChartData.labels) ? apiChartData.labels : []
  const values = Array.isArray(apiChartData.values) ? apiChartData.values : []
  const percentages = Array.isArray(apiChartData.percentages)
    ? apiChartData.percentages
    : []
  return labels.map((label, idx) => ({
    label,
    value: values[idx] || 0,
    percentage: percentages[idx] || 0,
  }))
}

function ClientsByCategories() {
  const [loading, setLoading] = useState(true)
  const [apiData, setApiData] = useState(null)

  useEffect(() => {
    Api.get("analytics/clients-by-category")
      .then((res) => {
        if (res.data) setApiData(res.data)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [])

  return (
    <div className="clients-by-category-chart">
      <div className="head">
        <h3>{trans("analytics.clientsByCategory")}</h3>
      </div>
      <hr />
      {loading ? (
        <Skeleton height={300} count={1} />
      ) : (
        <div className="cbc-list-wrapper">
          {getCategoriesFromApi(apiData?.chart_data).map((cat, idx, arr) => (
            <div className="cbc-row" key={cat.label}>
              <div className="cbc-row-head">
                <span className="cbc-label">{cat.label}</span>
                <span className="cbc-value">{cat.value}</span>
              </div>
              <div className="cbc-bar-bg">
                <div
                  className="cbc-bar"
                  style={{
                    background:
                      getColorVariationFromPrimaryColorBasedOnIndex(idx),
                    width: `${(cat.value / Math.max(...arr.map((c) => c.value), 1)) * 100}%`,
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default ClientsByCategories
